var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex"},[_c('router-view',{staticClass:"w-full p-x-6"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }